import { combineReducers } from 'redux';

import { BREADCRUMBS_CLEAR, BREADCRUMBS_SET } from './actions';

const breadcrumbs = (state = { items: [] }, action) => {
  if (action.type === BREADCRUMBS_SET) {
    return {
      ...state,
      items: action.payload,
    };
  }
  if (action.type === BREADCRUMBS_CLEAR) {
    return {
      ...state,
      items: [],
    };
  }
  return state;
};

export const reducer = combineReducers({
  breadcrumbs,
});
